import React from 'react';
import { Gift } from 'lucide-react';
import { Button } from './ui/Button';
import { bonuses } from '../data/constants';
export function Bonuses() {
  return <section className="py-16 md:py-24 px-4 max-w-6xl mx-auto" data-id="element-58">
      <div className="text-center mb-10 md:mb-14" data-id="element-59">
        <p className="text-primary font-bold uppercase tracking-widest text-[11px] md:text-sm mb-3 flex items-center justify-center gap-2" data-id="element-60">
          <Gift className="w-4 h-4" data-id="element-61" /> Bono exclusivo
        </p>
        <h2 className="text-2xl md:text-4xl font-extrabold leading-tight max-w-3xl mx-auto" data-id="element-62">
          🎁 Además te llevás este{' '}
          <span className="text-primary" data-id="element-63">bono gratis incluido</span>
        </h2>
        <p className="text-base md:text-lg text-zinc-300 mt-4" data-id="element-64">
          Se incluye automáticamente con tu compra. Sin costo extra.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 mb-10 md:mb-12 justify-center" data-id="element-65">
        {bonuses.map(b => <div key={b.id} className="group bg-surface border border-zinc-800 hover:border-primary/40 transition-colors p-5 md:p-6 rounded-2xl flex flex-col" data-id="element-66">
            <div className="flex items-start gap-3 mb-4" data-id="element-67">
              <div className="text-3xl md:text-4xl shrink-0" data-id="element-68">{b.icon}</div>
              <div className="min-w-0" data-id="element-69">
                <div className="text-[10px] md:text-xs font-bold text-primary uppercase tracking-wider mb-1" data-id="element-70">
                  Bono {b.id}
                </div>
                <h3 className="font-bold text-base md:text-lg text-white leading-tight" data-id="element-71">
                  {b.name}
                </h3>
              </div>
            </div>
            <p className="text-sm text-zinc-400 leading-relaxed mb-5 flex-grow" data-id="element-72">
              {b.desc}
            </p>
            <div className="flex items-center gap-2 pt-4 border-t border-zinc-800/70" data-id="element-73">
              <span className="text-zinc-500 line-through font-bold text-sm" data-id="element-74">
                Valor: {b.value}
              </span>
              <span className="ml-auto text-primary font-extrabold text-sm" data-id="element-75">
                GRATIS
              </span>
            </div>
          </div>)}
      </div>

      {/* Value close */}
      <div className="max-w-2xl mx-auto bg-gradient-to-r from-primary/10 to-primary/5 border border-primary/30 rounded-2xl p-6 md:p-7 text-center shadow-[0_0_30px_rgba(249,168,212,0.08)] mb-10" data-id="element-76">
        <p className="text-sm md:text-base text-zinc-300 mb-2" data-id="element-77">
          Valor total del bono:{' '}
          <span className="text-zinc-500 line-through font-bold" data-id="element-78">$9.900</span>
        </p>
        <p className="text-lg md:text-2xl font-extrabold text-white" data-id="element-79">
          Hoy va <span className="text-primary" data-id="element-80">incluido gratis</span> con tu
          compra.
        </p>
      </div>

      {/* Strategic CTA — single extra persuasive button */}
      <div className="text-center" data-id="element-81">
        <Button href="#pricing" className="text-base md:text-xl py-4 md:py-5 px-8 md:px-12 w-full md:w-auto" data-id="element-82">
          ⚡ AGARRAR MI BONO ANTES QUE EXPIRE
        </Button>
        <p className="text-xs md:text-sm text-zinc-500 mt-3" data-id="element-83">
          Solo al precio de lanzamiento · Puede eliminarse en cualquier momento
        </p>
      </div>
    </section>;
}